import type { Tier } from '@/hooks/use-pricing';
import { madridToday } from '@/utils/madrid-date';
import type { DailyEarning } from '../types';

export type TodayBounds = { tiers: Tier[]; dailyMin: number; scale: number };

// 31.9-revert: all-Madrid policy. Was UTC-slice in the original, briefly
// per-user-tz during 31.9.5, now Madrid — matching backend daily_earnings
// bucket labels and every other "today" anchor in the codebase.
export function todayCount(daily: DailyEarning[] | undefined): number {
  if (!daily?.length) return 0;
  const today = madridToday();
  return daily.find((d) => d.date.startsWith(today))?.lead_count ?? 0;
}

export function pctOf(n: number, max: number): number {
  return Math.min(100, Math.max(0, (n / Math.max(max, 1)) * 100));
}

export function computeBounds(
  tiers: Tier[],
  today: number,
  min: number
): TodayBounds {
  const lastMin = tiers[tiers.length - 1]?.min ?? 0;
  const scale = Math.max(lastMin * 1.25, today * 1.15, min * 1.25, 10);
  return { tiers, dailyMin: min, scale };
}
